
import React, { useRef, useEffect, useState } from 'react'
import Herramientas from './Herramientas'


const colors = [
    { id: "1", name: "yellow", cod: "yellow" },
    { id: "2", name: "green", cod: "#68DEA5" },
    { id: "3", name: "pink", cod: "#E274FC" }
]


const Game = ({setPlaying}) => {

    const [color, setColor] = useState(colors[0].cod)
    const [drawing, setDrawing] = useState(false)
    const [tool, setTool] = useState('pencil')

    const canvasRef = useRef(null)
    const contextRef = useRef(null)

    useEffect(() => {
        const canvas = canvasRef.current
        canvas.width = window.innerWidth * 2
        canvas.height = window.innerHeight * 2

        canvas.style.width = `${window.innerWidth}px`
        canvas.style.height = `${window.innerHeight}px`

        const context = canvas.getContext('2d')
        context.scale(2, 2)
        context.lineCap = "rounded"
        context.lineWidth = 7
        contextRef.current = context

    }, [])

    const startingDraw = ({ nativeEvent }) => {
        const { offsetX, offsetY } = nativeEvent
        contextRef.current.beginPath();
        contextRef.current.strokeStyle = color
        contextRef.current.moveTo(offsetX, offsetY);
        setDrawing(true)

    }

    const fininshDraw = (_event) => {
        contextRef.current.closePath()
        setDrawing(false)
    }

    const draw = ({ nativeEvent }) => {
        if (!drawing) return;
        const { offsetX, offsetY } = nativeEvent
        if (tool === 'pencil') {

            contextRef.current.lineTo(offsetX, offsetY)
            contextRef.current.stroke()
        } else {
            contextRef.current.clearRect(offsetX, offsetY, 21, 21);
        }

    }

    const handdleColor = (codeColor) => {
        setColor(codeColor);
        setTool('pencil')

    }

    const handdleTool = (codeColor) => {
        setColor(codeColor);
        setTool(codeColor)

    }


    return (
        <>
            <div className={`game`} style={{
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 100
            }}>
                <Herramientas
                    colors={colors}
                    activeColor={color}
                    setcolor={handdleColor}
                    setCleaning={handdleTool}
                    zIndex={3}
                    setPlaying={setPlaying}
                />
                <canvas
                    onMouseDown={startingDraw}
                    onMouseUp={fininshDraw}
                    onMouseMove={draw}
                    style={{ cursor: 'crosshair' }}
                    ref={canvasRef}

                />
            </div>

        </>
    )
}

export default Game
